import { KnBrCommonService } from './../services/kn-br-common.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import {
  AuthService,
  GlobalMessageService,
  WindowRef,
  GlobalMessageType,
  UrlPipe,
  TranslatePipe,
} from '@spartacus/core';
import { LoginFormComponent, LoginFormComponentService } from '@spartacus/user/account/components';
import { environment } from 'src/environments/environment';
import { KnBrAuthRedirectService } from '../services/kn-br-auth-redirect.service';
import { FormErrorsComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { Auth0Service } from '../services/knbr-new-auth0.service';
import { take } from 'rxjs';

@Component({
  selector: 'kn-br-login-form',
  templateUrl: './kn-br-login-form.component.html',
  styleUrls: ['./kn-br-login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormErrorsComponent, RouterLink, AsyncPipe, UrlPipe, TranslatePipe],
})
export class KnBrLoginFormComponent extends LoginFormComponent {
  errorMessage: string = 'Bad credentials. Please login again';
  loginInProgress = false;
  baseURL = environment.BASEURL;
  shouldShowLoginScreen = false;
  constructor(
    protected auth: AuthService,
    protected globalMessageService: GlobalMessageService,
    protected fb: UntypedFormBuilder,
    protected winRef: WindowRef,
    protected loginFormComponentService: LoginFormComponentService,
    protected knBrCommonService: KnBrCommonService,
    protected newAuthService: Auth0Service,
    private changeDetectorRef: ChangeDetectorRef,
    protected router: Router
  ) {
    super(loginFormComponentService);
    const isInIframe = window.self !== window.top;
    // *********************************
    // // NEVER COMMENT THIS CODE
    // if (this.baseURL.includes('p1') && !isInIframe) {
    //   this.redirectToNewAuth0SSO();
    //   // this.redirectToSSO(); // as old azure login is being removed
    // } else if (this.baseURL.includes('localhost') || this.baseURL.includes('d1')) {
    //   // this.redirectToNewSSO();
    // }
    // *********************************
  }
  ngOnInit(): void {
    // super.ngOnInit();
    this.knBrCommonService
      .getAuth0EnabledStatus()
      .pipe(take(1))
      .subscribe((responseData: any) => {
        const flagValue = responseData[0];
        this.redirectToAuth0PortalBasedOnTheFlag(flagValue);
      });
    if (this.winRef) {
      this.winRef.document.querySelector('kn-br-login-form').classList.add('knbr-user-form');
    }
  }

  redirectToAuth0PortalBasedOnTheFlag(auth0FlagValue) {
    console.log('its coming here', auth0FlagValue);
    if (auth0FlagValue === 'true') {
      this.redirectToNewAuth0SSO();
    } else {
      this.redirectToSSO();
    }
  }

  checkIsValidUser() {
    if (this.form.valid) {
      this.loginInProgress = true;

      const { userId, password } = this.form.controls;
      this.knBrCommonService.checkIsValidUser(userId.value).subscribe(
        (response: any) => {
          if (response?.response === 'Authorized') {
            this.onSubmit();
          } else {
            this.globalMessageService.add(response, GlobalMessageType.MSG_TYPE_ERROR);
          }
          this.loginInProgress = false;
          this.changeDetectorRef.detectChanges();
        },
        (error) => {
          const errorResponse = error.error;
          if (errorResponse && errorResponse.errors && errorResponse.errors.length > 0) {
            // this.globalMessageService.add(errorResponse.errors[0].message, GlobalMessageType.MSG_TYPE_ERROR);
            this.globalMessageService.add(this.errorMessage, GlobalMessageType.MSG_TYPE_ERROR);
          }
          this.loginInProgress = false;
          this.changeDetectorRef.detectChanges();
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }
  redirectToSSO() {
    window.open(environment.SSO, '_self');
  }

  async redirectToNewAuth0SSO() {
    const newUrl = await this.newAuthService.getAuthorizeUrl();
    window.open(newUrl, '_self');
  }
}
